import Router from "./Router";
import AuthContext from "./contexts/AuthContext";

const App = () => {
  return (
    <AuthContext>
      <Router />
    </AuthContext>
  );
};

export default App;
